<template>
  <div class="workAddDemand">
    <el-form ref="form" class="workAddDemand_form" :model="form" :rules="rules" label-width="120px">

      <el-form-item label="名称" prop="title">
        <el-input v-model="form.taskName" placeholder="请输入子工单名称" />
      </el-form-item>
      <el-form-item label="类型" prop="taskType">
        <el-radio-group v-model="form.taskType">
          <el-radio :label="1">开发</el-radio>
          <el-radio :label="2">设计</el-radio>
          <el-radio :label="3">测试</el-radio>
        </el-radio-group>
        <!-- <el-input v-model="" placeholder="请输入成员姓名" /> -->
      </el-form-item>
      <el-form-item label="成员" prop="userName">
        <el-select v-model="userSelectList" multiple filterable remote reserve-keyword placeholder="请输入用户名字"
          :remote-method="remoteFun" :loading="remoteLoading" @change="usermultiableChange()" value-key="id">
          <el-option v-for="(item, index) in usersubList" :key="index" :label="item.name" :value="item">
          </el-option>
        </el-select>
        <!-- <el-input v-model="form.userName" placeholder="请输入提出人" /> -->
      </el-form-item>
      <el-form-item label="紧急程度" prop="level">
        <span :class="form.level == 1 ? 'colorBox_actived colorBox' : 'colorBox'" @click="levelChange(1)"
          style="background: #F56C6C;"></span>
        <span :class="form.level == 2 ? 'colorBox_actived colorBox' : 'colorBox'" @click="levelChange(2)"
          style="background: #E6A23C;"></span>
        <span :class="form.level == 3 ? 'colorBox_actived colorBox' : 'colorBox'" @click="levelChange(3)"
          style="background: #409EFF;"></span>
        <!-- <el-input v-model="form.level" placeholder="请输入紧急程度" /> -->
      </el-form-item>
      <el-form-item label="计划开始时间" prop="planStartTime">
        <el-date-picker clearable v-model="form.planStartTime" type="date" value-format="yyyy-MM-dd"
          placeholder="请选择计划开始时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="计划结束时间" prop="planEndTime">
        <el-date-picker clearable v-model="form.planEndTime" type="date" value-format="yyyy-MM-dd"
          placeholder="请选择计划结束时间">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div class="btnBox">
      <el-button type="primary" class="btnBox_btn" @click="submitForm" :disabled="submitShow">确 定</el-button>
    </div>
  </div>
</template>

<script>
import { getInfo, addTask, updateDemand, listPersonnel } from '@/api/workOrder'
export default {
  name: "workAddOrder",
  data() {
    return {
      // 表单参数
      form: {
        id: null,
        orderId: null,
        taskType: null,
        level: null,
        userId: null,
        userName: null,
        planStartTime: null,
        planEndTime: null,
        realStartTime: null,
        realEndTime: null,
        status: null,
        extensionMessage: null,
        rejectMessage: null,
        createTime: null,
      },
      // 表单校验
      rules: {
        planStartTime: [
          { required: true, message: "计划开始时间不能为空", trigger: "blur" }
        ],
        planEndTime: [
          { required: true, message: "计划结束时间不能为空", trigger: "blur" }
        ],
      },
      userInfo: {},
      type: 1,
      submitShow: false,
      userSelectList: [],
      remoteLoading: false,
      usersubList: []
    };
  },
  mounted() {
    console.log(this.$route.params)
    if (this.$route.params.id && this.$route.params.id != 'null') {
      console.log(123)
      this.form.orderId = this.$route.params.id
    }
  },
  methods: {
    levelChange(type) {
      console.log(type)
      this.form.level = type
      console.log(this.form.level)
    },
    checkDate(selectedDate) {
      // 获取当前时间
      const today = new Date();
      // 将用户选择的时间转换为 Date 对象（注意格式兼容性）
      const selected = new Date(selectedDate);
      // 比较日期
      if (selected > today) {
        return 1;
      } else {
        return 2;
      }
    },
    /** 提交按钮 */
    submitForm() {
      if (this.userSelectList.length == 0) {
        this.$message({
          message: "请选择成员",
          type: "error",
        });
        return
      }
      if (!this.form.taskType) {
        this.$message({
          message: "请选择类型",
          type: "error",
        });
        return
      }
      if (this.form.planStartTime) {
        this.form.status = this.checkDate(this.form.planStartTime)
      }
      this.submitShow = true
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateDemand(this.form).then(response => {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              setTimeout(() => {
                this.$router.go(-1)
                this.submitShow = false
              }, 3000); // 2000毫秒后显示消息
            });
          } else {
            const idList = []
            const nameList = []
            this.userSelectList.forEach(e => {
              idList.push(e.id)
              nameList.push(e.name)
            });
            this.form.userId = idList.join(',')
            this.form.userName = nameList.join(',')
            addTask(this.form).then(response => {
              this.$message({
                message: '新增成功',
                type: 'success'
              });
              setTimeout(() => {
                this.$router.go(-1)
                this.submitShow = false
              }, 3000); // 2000毫秒后显示消息
            });
          }
        }
      });
    },
    uniqueByKey(array, key) {
      const seen = new Set();
      return array.filter(item => {
        const val = item[key];
        if (seen.has(val)) return false;
        seen.add(val);
        return true;
      });
    },
    remoteFun(query) {
      if (query !== '') {
        this.remoteloading = true;
        listPersonnel({
          pageNum: 1,
          pageSize: 999,
          name: query,
          companyId: this.$route.params.companyId
        }).then((response) => {
          const newOptions = [...response.rows];

          this.userSelectList.forEach(selected => {
            if (!newOptions.some(opt => opt.id === selected.id)) {
              newOptions.push(selected);
            }
          });
          // 去重（避免重复显示相同 id 的选项）
          const uniqueOptions = this.uniqueByKey(newOptions, 'id');
          this.usersubList = uniqueOptions;
          console.log(this.usersubList)
          this.remoteloading = false;
        });

      } else {
        this.usersubList = [];
      }
    },
    usermultiableChange() {
      console.log(this.userSelectList)
    },
  },
};
</script>
<style scoped>
.workAddDemand {
  padding: 10px;
  padding-left: 0;
  height: 95vh;
}

.workAddDemand_form {
  width: calc(100% - 10px);
}

.colorBox {
  display: inline-block;
  width: 25px;
  height: 25px;
  border-radius: 3px;
  margin-right: 10px;
}

.colorBox_actived {
  border: 1px solid #000;
}

.btnBox {
  width: 100%;
  text-align: center;
  margin-top: 20px;
}

.btnBox_btn {
  width: 90%;
}
</style>
<style>
.workAddDemand .el-icon-document {
  width: auto !important;
}
</style>